export const isOnline = () => Boolean(typeof navigator !== 'undefined' && navigator.onLine)
